// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"551":"627d4b0b","640":"f0793c5c"}[chunkId] + ".chunk.js");